import React from "react";

export default function Support() {
  return (
    <div className="min-h-screen bg-red-50 text-gray-800">
      <header className="sticky top-0 z-10 bg-red-50 backdrop-blur border-b">
        <div className="mx-auto max-w-3xl px-4 py-4 flex items-center justify-between">
          <h1 className="text-2xl font-semibold">Support</h1>
          <a href="/" className="text-sm underline hover:no-underline">
            ← Back to Home
          </a>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-4 py-10 space-y-8">
        <section className="rounded-2xl border p-6 shadow-md bg-white">
          <h2 className="text-xl font-medium">Get Help</h2>
          <p className="mt-3 leading-7">
            Need assistance with <span className="font-semibold">NameIt!</span>?
            We're here to help. Check the FAQs below or contact us directly.
          </p>
        </section>

        <section className="rounded-2xl border p-6 shadow-md bg-white">
          <h3 className="text-lg font-semibold">Contact Us</h3>
          <p className="mt-3">For bugs, feedback, or questions, reach us at:</p>
          <ul className="mt-3 space-y-2">
            <li>
              <span className="font-medium">Email:</span>{" "}
              <a className="underline" href="mailto:hillaryd97@gmail.com">
                hillaryd97@gmail.com
              </a>
            </li>
            <li>
              <span className="font-medium">TikTok:</span>{" "}
              <a
                className="underline"
                href="https://www.tiktok.com/@simi.hillary"
                target="_blank"
                rel="noopener noreferrer"
              >
                @simi.hillary
              </a>
            </li>
          </ul>
          <p className="mt-3 text-sm text-gray-600">
            We typically respond within 2-3 hours.
          </p>
        </section>

        <section className="rounded-2xl border p-6 shadow-md bg-white">
          <h3 className="text-lg font-semibold">Frequently Asked Questions</h3>

          <div className="mt-4 space-y-4">
            <div>
              <h4 className="font-medium">How do I join a game room?</h4>
              <p className="mt-1 text-sm text-gray-600">
                You can join a room in three ways: accept a link from a friend,
                enter a room code directly, or find one through the public rooms
                list.
              </p>
            </div>

            <div>
              <h4 className="font-medium">
                What are coins and how do I use them?
              </h4>
              <p className="mt-1 text-sm text-gray-600">
                Coins unlock premium features like expanding room size or
                changing time settings. You can purchase them{" "}
                <a href="https://name-it-ashy.vercel.app/account" className="text-red-600 font-bold underline">here</a>
              </p>
            </div>

            <div>
              <h4 className="font-medium">Important: Before buying coins</h4>
              <p className="mt-1 text-sm text-gray-600">
                The mobile app is linked to the website, but this connection may
                not always work perfectly.{" "}
                <span className="font-semibold">
                  Please ensure your email is linked to your account before
                  purchasing coins
                </span>{" "}
                to avoid losing access to your purchases.
              </p>
            </div>

            <div>
              <h4 className="font-medium">
                The game won't load or keeps crashing
              </h4>
              <p className="mt-1 text-sm text-gray-600">
                Try closing and reopening the app, or clearing your browser
                cache if playing on web. If the issue persists, contact us with
                your device/browser information and a description of what
                happened.
              </p>
            </div>

            <div>
              <h4 className="font-medium">I lost my coins or purchases</h4>
              <p className="mt-1 text-sm text-gray-600">
                If you've lost access to purchased coins, ensure you're logged
                in with the same email account you used when making the
                purchase. If the problem continues, contact us with your
                purchase receipt and account email.
              </p>
            </div>
          </div>
        </section>

        <section className="rounded-2xl border p-6 shadow-md bg-white">
          <h3 className="text-lg font-semibold">Report a Bug</h3>
          <p className="mt-3">Found a bug? Please contact us with:</p>
          <ul className="mt-2 list-disc pl-6 space-y-1 text-sm">
            <li>What you were doing when the bug occurred</li>
            <li>
              Your device type and operating system (iOS/Android) or browser
            </li>
            <li>Screenshots or screen recordings if possible</li>
            <li>Your account email (if applicable)</li>
          </ul>
        </section>

        <footer className="py-8 flex justify-center text-xs text-gray-500">
          <p>© {new Date().getFullYear()} NameIt! • Support</p>
        </footer>
      </main>
    </div>
  );
}
